import styled, { createGlobalStyle } from 'styled-components';
import { colors } from '../../const/color';
import { IconStyled } from '../icon';
import { ModalElementProps, ModalDialogProps } from './types';
import { modal } from './const';

export const BodyOverflowStyled = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

export const ModalWrapperStyled = styled.div<ModalElementProps & { backdrop?: boolean }>`
  position: fixed;
  overflow-y: auto;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 40;
  display: block;
  ${({ backdrop }) => backdrop && 'background: rgba(0, 0, 0, 0.6);'}
`;
export const ModalBackgroundStyled = styled.div<ModalElementProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
`;

export const ModalDialogStyled = styled.div<ModalDialogProps>`
  width: ${({ $size }) => modal[$size].width}px;
  background: ${colors.white};
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 20px;
  border-radius: 4px;
  margin: 50px auto 0;
`;

export const ModalHeaderStyled = styled.div<ModalElementProps>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px;
`;

export const ModalClose = styled.button`
  background-color: transparent;
  border: none;
  padding: 2px;
  cursor: pointer;
  ${IconStyled} * {
    fill: ${colors.grayDarker};
  }
  &:hover,
  &:focus {
    ${IconStyled} * {
      fill: ${colors.black};
    }
  }
`;

export const ModalBodyStyled = styled.div<ModalElementProps>`
  width: 100%;
  flex: 1;
  margin-bottom: 20px;
`;

export const ModalFooterStyled = styled.div<ModalElementProps>``;
